import { useEffect, useState } from "react";

import request from "helper/request";

/**
 * The client's Settings > Return Process defaults, for the plan page. Clients read their
 * own (list endpoint scoped by token); internal users read the selected client's.
 *
 * `settings` is null while loading or when the client has none configured; both switches
 * then default to off, which is what the backend does with no return-locations row.
 */
const useClientReturnProcess = ({ clientId, isAdmin }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (isAdmin && !clientId) {
      setSettings(null);
      setLoaded(false);
      return undefined;
    }
    setLoading(true);
    const load = isAdmin
      ? request.get(`/return-locations/by-client/${clientId}`)
      : request.get("/return-locations", { params: { page: 1, pageSize: 1 } });
    load
      .then((response) => {
        if (cancelled) return;
        const row = isAdmin ? response : response?.data?.[0];
        setSettings(row || null);
      })
      .catch(() => {
        if (!cancelled) setSettings(null);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [clientId, isAdmin]);

  return {
    settings,
    loading,
    loaded,
    defaults: {
      returnToPickupEnabled: !!settings?.enabledReturnPickup,
      returnOnFailedEnabled: !!settings?.enabled
    }
  };
};

export default useClientReturnProcess;
